import React, { useEffect, useState } from "react";
import "./ai-generated-objective-accordion.scss";
import { Dropdown } from "react-bootstrap";
import { EllipsisVertical } from "lucide-react";
import { useDispatch } from "react-redux";
import { ReactSVG } from "react-svg";
import StandardButton from "../../../../../shared/formComponents/StandardButton/StandardButton";
import { BoldText, LightText, NormalText, SmallNormalText } from "../../../../../../utils/typographyUtils";
import ButtonIcon from "../../../../../shared/formComponents/StandardButton/ButtonIcon";
import { KeyResultsAccordion } from "../../KeyResultsAccordion/KeyResultsAccordion";
import { InitiativesAccordion } from "../../InitiativesAccordion/InitiativesAccordion";

export const AIGeneratedObjectiveAccordion = ({
  objective,
  businessPlanId,
  isPlanPublished,
  callBack,
  closeAllAccordions,
  showActions
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [ownerName, setOwnerName] = useState("");
  const [showAddKeyResultField, setShowAddKeyResultField] = useState(false);
  const [showDeleteKeyResultPopup, setShowDeleteKeyResultPopup] =
    useState(false);
  const [showConfirmationButtons, setShowConfirmationButtons] = useState({
    show: false,
    id: "",
  });
  const [isExpanded, setIsExpanded] = useState(false);
  const [showChangeOwnerPopup, setShowChangeOwnerPopup] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [originalObjective, setOriginalObjective] = useState(
    objective.description,
  );
  const handleShowObjectiveButtons = () => {
    return (
      <div className="d-flex py-2 align-items-center">
        <ReactSVG
          src="/assets/images/light_close_icon.svg"
          className="ms-3 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            setShowConfirmationButtons({ show: false, type: "" });
          }}
        />
        <StandardButton
          className="ms-2 py-1"
          color="btn-brand-blue-new"
          disabled={true}
          text="Save"
          darkLoader={true}
        />
      </div>
    );
  };
  const renderObjectiveActionsDropdown = () => {
    return (
      <Dropdown
        onClick={(e) => e.stopPropagation()}
        id="ai-generated-objective-dropdown"
        drop={`start`}
      >
        <Dropdown.Toggle>
          <LightText classNames={`cursor-pointer`}>
            <ButtonIcon icon={EllipsisVertical} />
          </LightText>
        </Dropdown.Toggle>
        <Dropdown.Menu
          id="dropdown-basic"
          className="objective-dropdown-menu"
          style={{ transform: "translate3d(0px, -45px, 0px)" }}
        >
          <Dropdown.Item
            disabled={true}            
          >
            Edit Objective
          </Dropdown.Item>
          <Dropdown.Item disabled={true}>
            Change Owner
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };
  return (
    <div id="ai-generated-objective-accordion">
      <div className="border cs-br-8 m-3 ai-generated-objective-accordion-item">
        {/* HEADER */}
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className="d-flex align-items-center p-3 cursor-pointer ai-generated-objective-accordion-item-header"
        >
          <div
            className={`${showConfirmationButtons.type === "update" &&
                showConfirmationButtons.id === objective.businessPlanObjectiveId
                ? "mt-2"
                : ""
              }`}
          >
            <div className="d-flex align-items-center">
              <img src="/assets/images/objectives.svg" />
              <BoldText classNames={"ms-3 light-text"}>Objective</BoldText>
            </div>
          </div>
          <div className="d-flex flex-column ms-3 align-items-start w-75">
            <NormalText classNames={"objective-div"}>
              {objective.description}
            </NormalText>
          </div>
          <div className="ms-auto d-flex flex-column justify-content-between align-items-end">
            <div className="d-flex align-items-center">
              <div className="name-initial-div">
                {objective.ownerName?.charAt(0)}
              </div>
              <SmallNormalText classNames="mx-2 initial-text">
                {objective.ownerName.length > 12
                  ? objective.ownerName.substring(0, 9) + "..."
                  : objective.ownerName}
              </SmallNormalText>
              {renderObjectiveActionsDropdown()}
              <div className="ms-3 ai-generated-objective-accordion-header-arrow">
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                  }}
                  className="cursor-pointer"
                  src={`/assets/images/${isExpanded ? "up-arrow.svg" : "down-arrow.svg"}`}
                />
              </div>
            </div>
          </div>
        </div>
        {/* CONTENT */}
        <div
          className={`ai-generated-objective-accordion-body ${isExpanded ? "open" : ""}`}
        >
          <KeyResultsAccordion
            isExpanded={isExpanded}
            showOnHoverText={true}
            callBack={callBack}
            data={objective.keyResults ?? []}
            isPlanPublished={isPlanPublished}
            objectiveId={objective.businessPlanObjectiveId}
            showAddKeyResultField={showAddKeyResultField}
            setShowAddKeyResultField={setShowAddKeyResultField}
            setShowDeleteKeyResultPopup={setShowDeleteKeyResultPopup}
            showDeleteKeyResultPopup={showDeleteKeyResultPopup}
            closeAllAccordions={closeAllAccordions}
            showActions={showActions}
          />
          <InitiativesAccordion
            disableProgress={true}
            showOnHoverText={true}
            isPlanPublished={isPlanPublished}
            initiatives={objective.initiatives ?? []}
            callBack={callBack}
            //   disableOperations={handleDisableOperations()}
            objectiveId={objective.businessPlanObjectiveId}
            closeAllAccordions={closeAllAccordions}
            showActions={showActions}
          />
        </div>        
      </div>
    </div>
  );
};
